export const useLocale = () => {
  const nuxtApp = useNuxtApp()
  const locale = nuxtApp.vueApp.config.globalProperties.$i18n.locale
  return locale
}
